export default "<app-header></app-header>\n\n<main>\n    <router-outlet></router-outlet>\n  \n</main>";